var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2961 13.628L8.59393 18.0317C8.04914 18.4585 7.27735 18.4585 6.73256 18.0317L1.0395 13.628C0.667225 13.3375 0.449309 12.8925 0.449309 12.4204V1.76974C0.440229 0.925312 1.12122 0.244324 1.96564 0.244324H13.3608C14.2053 0.244324 14.8863 0.925312 14.8863 1.76974V12.4204C14.8863 12.8925 14.6683 13.3375 14.2961 13.628Z",
    fill: "#38539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTag);
export default __webpack_public_path__ + "static/media/blue_tag.c80768f530001c97dcb920b188b074db.svg";
export { ForwardRef as ReactComponent };